import React, { useState } from 'react';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import AppAddPillButton from '../../../../components/designe/buttons/app-add-pill-button/AppAddPillButton';
import NoResults from '../../../../components/reusable/no-results';
import Search from '../../../../components/reusable/search/Search';
import WithListObservers from '../../../../hoc/with-list-observers';
import { IProgramItem } from '../../../../types/interfaces/program-item';
import { orderBy } from '../../../../utils/collections/array-utils';
import { useStyles } from './ProgramItemList.styles';
import ProgramItemListItem from './program-item-list-item/ProgramItemListItem';
import { ProgramListKind } from './program-item-list-item/program-list-subtitle';
import ProgramItemSkeleton from './program-item-skeleton/ProgramItemSkeleton';

const SKELETON_COUNT = 4;

interface IProgramItemsListProps {
  programItems: IProgramItem[] | null | undefined;
  onAddClick?: () => void;
  isLoading?: boolean;
  /** Same as trainings: «Мои» vs «Доступные» — подзаголовок «от кого». */
  listKind?: ProgramListKind;
  emptyStateBanner?: React.ReactNode;
}

const ProgramItemsList = (props: IProgramItemsListProps) => {
  const {
    programItems,
    onAddClick,
    isLoading = false,
    listKind = 'my',
    emptyStateBanner,
  } = props;
  const theme = useTheme();

  const { classes } = useStyles(theme);

  const [filter, setFilter] = useState('');
  const filteredProgramItems = programItems
    ? orderBy(
        programItems?.filter(
          (item) =>
            item.title.toLowerCase().indexOf(filter?.toLowerCase()) !== -1,
        ) || [],
        'orderNumber',
      )
    : null;
  const showNoResult =
    !isLoading && !!filteredProgramItems && !filteredProgramItems?.length;

  return (
    <div className={classes.programItemListWrapper}>
      <Box className={classes.programItemListHeader}>
        <Search
          fullWidth
          value={filter}
          onChange={setFilter}
          className={classes.programItemsListSearch}
        />
        {onAddClick && (
          <AppAddPillButton
            data-onboarding="programPage.action.createProgram"
            onClick={() => onAddClick()}
          />
        )}
      </Box>

      {isLoading && (
        <WithListObservers
          wrapperClassName={clsx(
            classes.programItemListBody,
            onAddClick && classes.programItemListBodyWithAddButton,
          )}>
          <Box display="flex" flexDirection="column">
            {Array.from({ length: SKELETON_COUNT }, (_, i) => (
              <ProgramItemSkeleton key={i} />
            ))}
          </Box>
        </WithListObservers>
      )}

      {!isLoading &&
        filteredProgramItems &&
        filteredProgramItems.length > 0 && (
          <WithListObservers
            wrapperClassName={clsx(
              classes.programItemListBody,
              onAddClick && classes.programItemListBodyWithAddButton,
            )}>
            {filteredProgramItems.map((programItem) => (
              <ProgramItemListItem
                key={programItem.id}
                programItem={programItem}
                listKind={listKind}
              />
            ))}
          </WithListObservers>
        )}

      {showNoResult && emptyStateBanner && <Box mt={1}>{emptyStateBanner}</Box>}
      {showNoResult && <NoResults />}
    </div>
  );
};

export default ProgramItemsList;
